// features/campaign.validation.js

export const campaignValidation = {
  campaign_name: (value) => {
    if (!value?.trim()) return "Campaign name is required.";
    return "";
  },
};
